import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import {
  Box,
  Chip as MuiChip,
  Divider as MuiDivider,
  Grid,
  IconButton,
  Paper as MuiPaper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Toolbar,
  Tooltip,
  Typography,
  CircularProgress,
  FormControlLabel,
  Switch,
  Breadcrumbs,
  TextField,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  TextareaAutosize,
} from "@material-ui/core";

import { green, orange, red } from "@material-ui/core/colors";
import {
  RemoveRedEye as RemoveRedEyeIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
} from "@material-ui/icons";
import { spacing } from "@material-ui/system";
import {
  HighlightProduct,
  getProducts,
} from "../NetworkCalls/Products/ServerReq";
import ButtonIconComponent from "../Components/ButtonIcons";
import SearchBar from "../Components/SearchBar";
import { ExportToExcel } from "../Components/ExportToExcel";
import ImportExcel from "../Components/ImportExcel";
import SwitchCheck from "../Components/SwitchCheck";
import TimeRangeField from "../Components/TimeRangeField";
import AddMenuItemModal from "../Components/modals/AddMenuItemModal";
import {
  AddSingleDocNestedCollection,
  GetAllData,
  GetAllDataNestedCollections,
} from "../NetworkCalls/Admin/ServerReq";
const Divider = styled(MuiDivider)(spacing);
const Paper = styled(MuiPaper)(spacing);
const Chip = styled(MuiChip)`
  ${spacing};
  background: ${(props) => props.shipped && green[500]};
  background: ${(props) => props.processing && orange[700]};
  background: ${(props) => props.cancelled && red[500]};
  color: #fff;
`;

const Spacer = styled.div`
  flex: 1 1 100%;
`;

const ToolbarTitle = styled.div`
  min-width: 150px;
`;

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: "id", alignment: "left", label: "S.No" },
  { id: "menu", alignment: "left", label: "Menu" },
  { id: "description", alignment: "left", label: "Description" },
  { id: "category", alignment: "left", label: "Category" },
  { id: "price", alignment: "left", label: "Price" },
];

function BasicBreadcrumbs() {
  return (
    <div role="presentation">
      <Breadcrumbs aria-label="breadcrumb">
        <Link
          to={"/dashboard/daily_specials"}
          underline="hover"
          color="#000"
          style={{ color: "#410660" }}
        >
          {" "}
          Daily Specials
        </Link>
        <Typography
          color="text.primary"
          style={{ fontWeight: "500", color: "#410660" }}
        >
          KFC
        </Typography>
      </Breadcrumbs>
    </div>
  );
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.alignment}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <Box>
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
                style={{ color: "#969696", fontWeight: 600 }}
              >
                {headCell.label}
              </TableSortLabel>
            </Box>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

let EnhancedTableToolbar = (props) => {
  const { numSelected } = props;
  const [searched, setSearched] = React.useState("");

  return (
    <div
      style={{
        display: "flex",
        // width: "350px",
        alignItems: "center",
        marginLeft: "1rem",
        marginTop: "1rem",
      }}
    >
      <div style={{ width: "30%" }}>
        <SearchBar
          label="Search Daily Specials"
          value={searched}
          onChange={(val) => {
            setSearched(val);
            props.onSearch(val);
          }}
        />
      </div>
    </div>
  );
};

function EnhancedTable({ data, setData }) {
  const params = useParams();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("customer");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [loader, setLoader] = React.useState(false);
  const [fixedData, setFixedData] = React.useState([]);
  const [Refresh, setRefresh] = React.useState(false);
  const [isSwitchEnabled, setIsSwitchEnabled] = useState(false);

  useEffect(() => {
    const getAllKidsMenu = async () => {
      try {
        setLoader(true);
        const response = await GetAllDataNestedCollections(
          "Restaurants",
          params.restaurantid,
          "KidsMenu"
        );

        setData(response);

        setLoader(false);
      } catch (err) {
        console.log(err);
        setLoader(false);
      } finally {
        setLoader(false);
      }
    };

    getAllKidsMenu();
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = data.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

  const handleSearch = (val) => {
    console.log(val);
    if (!val) {
      setData(fixedData);
      return;
    }
    const filteredRows = fixedData.filter((row) => {
      return row.title?.toLowerCase().includes(val?.toLowerCase());
    });
    console.log(filteredRows);
    setData(filteredRows);
  };
  const history = useNavigate();

  const [open, setOpen] = React.useState(false);

  const [DeleteUid, setDeleteUid] = useState("");
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      {loader ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </div>
      ) : (
        <>
          <Paper
            style={{
              boxShadow: "none !important",
              border: "1px solid rgba(76, 78, 100, 0.25)",
              borderRadius: "10px",
            }}
          >
            <TableContainer style={{ height: "70vh" }}>
              <Table
                aria-labelledby="tableTitle"
                size={"medium"}
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={data.length}
                />

                <TableBody>
                  {stableSort(data, getComparator(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      const isItemSelected = isSelected(row.id);
                      return (
                        <TableRow
                          // onClick={()=>history("/dashboard/add_menu")}

                          hover
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={`${row.id}-${index}`}
                          selected={isItemSelected}
                        >
                          <TableCell align="left">
                            <Typography
                              style={{ fontWeight: "600", fontSize: "16px" }}
                            >
                              {index + 1}.
                            </Typography>{" "}
                          </TableCell>

                          <TableCell align="left">
                            {" "}
                            <Typography
                              style={{ fontWeight: "600", fontSize: "16px" }}
                            >
                              {row?.menu === undefined ? "Menu" : row?.menu}
                            </Typography>{" "}
                          </TableCell>

                          <TableCell align="left">
                            {" "}
                            <Typography
                              style={{ fontWeight: "600", fontSize: "16px" }}
                            >
                              {row?.description === undefined
                                ? "description"
                                : row?.description}
                            </Typography>{" "}
                          </TableCell>

                          <TableCell align="left">
                            {" "}
                            <Typography
                              style={{ fontWeight: "600", fontSize: "16px" }}
                            >
                              {row?.category === undefined
                                ? "category"
                                : row?.category}
                            </Typography>{" "}
                          </TableCell>

                          <TableCell align="left">
                            {" "}
                            <Typography
                              style={{ fontWeight: "600", fontSize: "16px" }}
                            >
                              {row?.price === undefined ? "price" : row?.price}
                            </Typography>{" "}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </Paper>

          {/* <DeleteProduct
						open={open}
						data={DeleteUid}
						setData={setData}
						handleOpen={handleOpen}
						setRefresh={setRefresh}
						handleClose={handleClose}
					/> */}
        </>
      )}
    </div>
  );
}

const KidsMenu = () => {
    const params = useParams()
  let [data, setData] = React.useState([]);
  const [loader, setLoader] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [dataAddKidsMenu, setDataAddKidsMenu] = useState({});
  const [addMenuLoading, setAddmenuLoading] = useState(false);

  console.log(dataAddKidsMenu)

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const getAllCategories = async () => {
      try {
        setLoader(true);
        const response = await GetAllData("Categories");

        let arr = [];
        response.forEach((doc) => {
          arr.push(doc.data());
        });

        arr.sort((a, b) => a.name.localeCompare(b.name));

        setCategories(arr);

        setLoader(false);
      } catch (err) {
        console.log(err);
        setLoader(false);
      } finally {
        setLoader(false);
      }
    };

    getAllCategories();
  }, []);

  const handleOnchange = (e) => {
    const { name, value } = e.target;

    if (name === "category") {
      setSelectedCategory(value);
    }

    setDataAddKidsMenu((preValue) => {
      return {
        ...preValue,
        [name]: value,
      };
    });
  };

  const handleAddKidsMenu = async () => {
    setAddmenuLoading(true);

    try {
      await AddSingleDocNestedCollection(
        "Restaurants",
        params?.restaurantid,
        "KidsMenu",
        dataAddKidsMenu
      );

      setAddmenuLoading(false);
      handleClose()
    } catch (e) {
     
      setAddmenuLoading(true);
    } finally {
      setAddmenuLoading(false);
    }
  };

  return (
    <React.Fragment>
      <AddMenuItemModal
        open={open}
        handleOpen={handleOpen}
        handleClose={handleClose}
      >
        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            marginBottom: "1rem",
          }}
        >
          <Typography
            gutterBottom
            variant="h1"
            style={{
              fontWeight: "600",
              fontSize: "30px",
              textAlign: "center",
              margin: "0",
            }}
          >
            Add Item
          </Typography>
        </Box>

        <Box
          style={{
            margin: "2rem 0 0 auto",
          }}
        >
          <Grid style={{ marginBottom: "15px" }} container spacing={3}>
            {" "}
            {/* Add spacing prop */}
            <Grid item xs={12} xl={12} lg={12} md={12}>
              <TextField
                id="outlined-basic"
                type="text"
                name="menu"
                variant="outlined"
                fullWidth
                label="Menu name"
                onChange={handleOnchange}
              />
            </Grid>
            <Grid item xs={12} xl={12} lg={12} md={12}>
              <TextField
                id="outlined-basic"
                name="price"
                label="Price"
                variant="outlined"
                type="number"
                fullWidth
                onChange={handleOnchange}
              />
            </Grid>
            <Grid item xs={12} xl={12} lg={12} md={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Select menu category
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Enter menu category"
                  name="category"
                  value={selectedCategory}
                  onChange={handleOnchange}
                >
                  {categories &&
                    categories.map((item, index) => (
                      <MenuItem key={index} value={item?.id}>
                        {item?.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} xl={12} lg={12} md={12}>
              <FormControl fullWidth={true} variant="outlined">
                {/* <InputLabel id="description">Desciption</InputLabel> */}
                <Typography> Desciption</Typography>
                <TextareaAutosize
                  htmlFor="description"
                  name="description"
                  variant="outlined"
                  type="text"
                  onChange={handleOnchange}
                  minRows={6}
                  style={{
                    border: "1px solid #c4c4c4",
                    width: "100%",
                    fontSize: "16px",
                    padding: "15px",
                    outline: "none",
                  }}
                  placeholder="Write here..."
                />
              </FormControl>
            </Grid>
          </Grid>

          <ButtonIconComponent
            loader={addMenuLoading}
            name="Submit"
            onClick={handleAddKidsMenu}
            
            imageBool={false}
          />
        </Box>
      </AddMenuItemModal>

      <Grid
        style={{ marginBottom: "10px", alignItems: "center" }}
        justify="space-between"
        container
        // spacing={24}
      >
        <Grid item>
          <Typography
            gutterBottom
            variant="h3"
            display="inline"
            style={{
              fontWeight: "700",
              letteSpacing: "0.2px",
              fontSize: "25px",
            }}
          >
            Kids Menu
          </Typography>
        </Grid>

        <Grid
          style={{
            marginRight: "20px",
          }}
        >
          <ButtonIconComponent
            loader={false}
            name="Add Item "
            onClick={handleOpen}
            imageBool={false}
          />
        </Grid>
      </Grid>

      <Divider
        style={{
          marginTop: "20px",
          marginBottom: "10px",
          backgroundColor: "#fafafa",
        }}
      />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <BasicBreadcrumbs />
        </Grid>
      </Grid>

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <EnhancedTable data={data} setData={setData} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default KidsMenu;
